import AppHeader from "@/components/AppHeader";

export default {
  name: "accident-history-new",
  components: {
    AppHeader
  },
  async created() {
    this.getUser();
    await this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      changeYear: "",
      changeMonth: "",
      changeDay: "",
      accidentHistory: {
        user_id: this.$route.params.user_id,
        content: ""
      },
      user: "",
      savingFlag: false
    };
  },
  computed: {
    changeDateFormat() {
      return this.changeYear + "-" + this.changeMonth + "-" + this.changeDay;
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.changeMonth, this.changeDay, 0).getDate();
    },
    async createAccidentHistory() {
      if (this.savingFlag) return;
      this.savingFlag = true;
      this.accidentHistory.change_date = this.changeDateFormat;
      let data = this.accidentHistory;
      let res = await this.$store
        .dispatch("CREATE_ACCIDENT_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goAccidentHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goAccidentHistory() {
      this.$router.push({
        path: `/accident_history/${this.$route.params.user_id}`
      });
    },
    getDayCount() {
      this.changeDay = "";
      this.dayCount = new Date(this.changeYear, this.changeMonth, 0).getDate();
    }
  }
};
